import { Injectable } from "@angular/core";
import moment from "moment";
import "moment/locale/it";
import "moment/locale/pt"

@Injectable({ providedIn: "root" })
export class LocaleService {
  public locale: string;

  constructor() {
    this.locale = navigator.language;
    moment.locale(this.locale);
    console.log("LOCALE", this.locale, moment.locale());
    
  }
}
